// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { ColumnStats, FrequentValue, TableProfile } from "../profiling/dto.generated";
export const addTagTypes = ["mcp"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiProjectsByProjectIdTablesAndTableNameProfile: build.query<
        GetApiProjectsByProjectIdTablesAndTableNameProfileApiResponse,
        GetApiProjectsByProjectIdTablesAndTableNameProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/${encodeURIComponent(String(queryArg.tableName))}/profile`,
        }),
        providesTags: ["mcp"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as profilingApi };
export type GetApiProjectsByProjectIdTablesAndTableNameProfileApiResponse =
  /** status 200 OK */ { data: ProfilingTableProfile };
export type GetApiProjectsByProjectIdTablesAndTableNameProfileApiArg = {
  /** Project ID */
  projectId: string;
  /** Table name */
  tableName: string;
};
export type ProfilingFrequentValue = FrequentValue;
export type ProfilingColumnStats = ColumnStats;
export type ProfilingTableProfile = TableProfile;
export const {
  useGetApiProjectsByProjectIdTablesAndTableNameProfileQuery,
  useLazyGetApiProjectsByProjectIdTablesAndTableNameProfileQuery,
} = injectedRtkApi;
